module.exports = __webpack_public_path__ + "static/media/biltenko.a91037b6.png";